import { useCheckout } from '@/lib/hooks'
import { cn, formatPrice, formatTimestamp } from '@/lib/utils'

import { Badge, Label } from '@/components/ui'
import { DeletePayment } from '@/components/molecules'

interface CheckoutViewPaymentsProps
  extends React.ComponentPropsWithoutRef<'div'> {}

export const CheckoutViewPayments = ({
  className,
  ...restProps
}: CheckoutViewPaymentsProps) => {
  const { payments } = useCheckout()

  return (
    <div className={cn('flex flex-col gap-2 px-6', className)} {...restProps}>
      {payments?.map((payment, index) => {
        if (payment?.status === 'void') {
          return null
        }

        return (
          <div
            key={index}
            className="flex items-center gap-3 rounded-lg border border-gray-100 px-3 pb-2.5 pt-2 shadow-card"
          >
            <div className="flex w-full flex-col">
              <div className="flex w-full items-center gap-1">
                <Label htmlFor={payment?.id} className="text-base font-medium">
                  {formatPrice(payment?.amount_paid, 2, true)}
                </Label>

                <Badge size="md" className="capitalize">
                  {payment.status}
                </Badge>
              </div>
              <div className="flex flex-col">
                <span className="text-xs font-medium capitalize text-gray-950">
                  {payment.code}
                </span>
                <span className="text-xs font-medium capitalize text-gray-700">
                  {formatTimestamp(payment?.created_at)}
                </span>
              </div>
            </div>

            <DeletePayment paymentId={payment?.id} />
          </div>
        )
      })}
    </div>
  )
}
